import React from 'react';

import { Divider } from 'redpoints-front-components/index';
import { LinkDataCommonForm } from 'redpoints-front-common/components';

import { translate } from '../../../helpers/languageHelper';

const IncidentDetailsLinkDataCommon = ({
  commonLinkData,
  commonLinkDataChange,
  commonLinkDataValidate,
  commonLinkMetadata,
  editable = true,
  forceValidation,
}) => (
  <>
    <Divider />
    <h3>{translate('reporting.incidentDetails.common.title')}</h3>
    <LinkDataCommonForm
      commonLinkData={commonLinkData}
      commonLinkMetadata={commonLinkMetadata}
      editable={editable}
      forceValidation={forceValidation}
      onChange={commonLinkDataChange}
      onValidate={commonLinkDataValidate}
      shouldIgnoreMandatoryValidation
    />
  </>
);

export default IncidentDetailsLinkDataCommon;
